import { render, staticRenderFns } from "./AccessRequests.vue?vue&type=template&id=16d59754"
import script from "./AccessRequests.vue?vue&type=script&lang=js"
export * from "./AccessRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports